import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface FilterChipProps {
  label: string;
  value: string;
  active?: boolean;
  onDismiss?: () => void;
}

/**
 * Inline filter chip rendered in the FilterToolbar. Mirrors
 * `.toolbar__chip` / `.toolbar__chip--active` from
 * mockup--opportunity-list.css:143-164.
 */
export function FilterChip({
  label,
  value,
  active = false,
  onDismiss,
}: FilterChipProps) {
  return (
    <span
      data-active={active ? "true" : "false"}
      className={cn(
        "inline-flex items-center gap-1 px-3 py-1",
        "rounded-full border typo-label normal-case tracking-normal",
        active
          ? "border-[color-mix(in_srgb,var(--color-accent)_40%,transparent)] bg-[color-mix(in_srgb,var(--color-accent)_10%,transparent)] text-[color:var(--color-accent)]"
          : "border-[color:var(--color-border)] bg-[color:var(--color-surface)] text-[color:var(--color-text-md)]",
      )}
    >
      <span>
        <span className="font-medium">{label}:</span> {value}
      </span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label={`Remove ${label} filter`}
          className="ml-1 text-[color:var(--color-text-lo)] hover:text-[color:var(--color-text-hi)] transition-colors"
        >
          <X className="h-3 w-3" aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
